<div class="container page-margin-1">
    <div class="title">cartas</div>
    <dsm-cartas [cartas]="cartas"></dsm-cartas>
</div>